var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/* eslint-disable no-restricted-imports */
import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctInteger128, FctValue, FctValue18 } from '../../../../Fct/generics/FctParams';
import { getSupportedIndexes, supportedPools } from '../helpers/supportedContracts';
export var CalculateWithdrawOneCoin = createPlugin({
    protocol: 'CURVE',
    type: 'GETTER',
    method: 'calc_withdraw_one_coin',
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({
                    destination: 'curve_pool',
                    options: supportedPools.filter(function (pool) { return pool.chainId === Number(chainId); }),
                }),
                methodParams: {
                    tokenAmount: new FctValue({}),
                    indexOfCoin: new FctInteger128({}),
                },
            },
            output: { amount: new FctValue18({ innerIndex: 0, destination: 'wei_amount' }) },
        });
    },
    initParams: {
        methodParams: {
            isDeposit: 'false',
        }
    },
    calculateValuesOnUserInput: function (_a) {
        var input = _a.input, chainId = _a.chainId;
        var getParamsAsync = function () { return __awaiter(void 0, void 0, void 0, function () {
            var address, indexOfCoin;
            return __generator(this, function (_a) {
                address = input === null || input === void 0 ? void 0 : input.to.value;
                indexOfCoin = input === null || input === void 0 ? void 0 : input.methodParams.indexOfCoin;
                if (!address) {
                    indexOfCoin.options = [];
                    return [2 /*return*/, {
                            params: {},
                            error: undefined,
                        }];
                }
                if (indexOfCoin)
                    indexOfCoin.options = getSupportedIndexes(address, chainId);
                return [2 /*return*/, {
                        params: {},
                        error: undefined,
                    }];
            });
        }); };
        return { get: getParamsAsync, depParamKeys: ['to'] };
    },
});
